// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreferencesPane_wrapper__3V0Cn"};